import Input from "@/components/common/Input";
import LayerIcon from "@/components/common/LayerIcon";
import { Layer } from "@/interfaces/template.interface";

interface Props {
  data: Layer;
}

const Name = ({ data }: Props) => {
  const value = data.name;
  return (
    <div className="flex items-center">
      {LayerIcon({ type: data.customType, size: 20 })}
      <Input className="pointer-events-none border-0" value={value} readOnly />
    </div>
  );
};

const FunctionalId = ({ data }: Props) => {
  const value = data.functionalId;
  return <div className="truncate">{`#${value}`}</div>;
};

export { Name, FunctionalId };
